import { useState } from 'react';
import { Dialog, api, useToast } from './_barrel.js';


        // Dialog shown when an analyst wants to create a new Subject from a
        // Companies House officer AND link them to the business in one go.
        function LinkOfficerToSubjectDialog({ token, onClose, onSuccess, businessId, officer }) {
            const [purpose, setPurpose] = useState(
                `Protective intelligence: linked from ${officer.role || 'officer'} appointment via Companies House.`
            );
            const [submitting, setSubmitting] = useState(false);
            const [error, setError] = useState(null);
            const toast = useToast();

            // CH names are "SURNAME, Forename Other" — flip for display_name
            const ch_name = officer.name || '';
            let display_name = ch_name;
            if (ch_name.includes(',')) {
                const parts = ch_name.split(',').map(p => p.trim());
                if (parts.length === 2) display_name = `${parts[1]} ${parts[0]}`;
            }

            const [fullName, setFullName] = useState(display_name);

            const submit = async () => {
                if (!fullName.trim()) { setError('Full name required'); return; }
                setSubmitting(true); setError(null);
                try {
                    // 1. Create the Subject
                    const subj = await api('/api/v1/subjects', {
                        method: 'POST',
                        body: JSON.stringify({
                            subject_type_code: 'other',
                            full_name: fullName.trim(),
                            display_name: null,
                            year_of_birth: officer.dob_year || null,
                            occupation: officer.occupation || null,
                            processing_purpose: purpose.trim(),
                            lawful_basis: 'legitimate_interests',
                            aliases: [],
                            handles: [],
                        }),
                    }, token);
                    // 2. Create the link
                    const link_type = (officer.role || 'director').toLowerCase().replace(/[^a-z]/g, '_').slice(0, 64);
                    await api(`/api/v1/businesses/${businessId}/links`, {
                        method: 'POST',
                        body: JSON.stringify({
                            subject_id: subj.id,
                            link_type,
                            ch_officer_id: officer.officer_id,
                            appointed_at: officer.appointed_on,
                            resigned_at: officer.resigned_on,
                            is_current: officer.is_current,
                        }),
                    }, token);
                    toast(`Created Subject for ${fullName.trim()} and linked.`);
                    onSuccess?.(); onClose();
                } catch (e) { setError(e.message); }
                finally { setSubmitting(false); }
            };

            return (
                <Dialog onClose={onClose} title={`Create Subject from ${ch_name}`}>
                    <div className="space-y-4">
                        <div className="text-sm text-muted">
                            Creating a new Subject record for this officer and linking them to the business.
                            The Subject's processing basis defaults to legitimate interests — adjust afterwards
                            via Edit Subject if needed.
                        </div>
                        <div>
                            <label>Full Name *</label>
                            <input value={fullName} onChange={e => setFullName(e.target.value)} />
                            <div className="text-xs text-muted mt-1 font-mono">
                                CH had: {ch_name}
                            </div>
                        </div>
                        <div>
                            <label>Processing Purpose</label>
                            <textarea rows="2" value={purpose} onChange={e => setPurpose(e.target.value)} />
                        </div>
                        {error && <div className="text-sm" style={{color:'var(--red)'}}>{error}</div>}
                        <div className="flex justify-end gap-2 pt-2">
                            <button className="btn-ghost" onClick={onClose}>Cancel</button>
                            <button className="btn-gold" onClick={submit} disabled={submitting}>
                                {submitting ? 'Creating…' : 'Create + Link'}
                            </button>
                        </div>
                    </div>
                </Dialog>
            );
        }

export { LinkOfficerToSubjectDialog };
